export const ROLES = {
  EXECUTIVE: 3,
  TEAM_COORDINATOR: 5,
  TEAM_LEAD: 2,
  ADMIN: 1,
  CALL_AUDIT_EXECUTIVE: 6,
  MARKETING_MANAGER: 7,
};

export const ROLE = {
  ADMIN: "Admin",
  TEAM_LEAD: "Team Lead",
  TEAM_COORDINATOR: "Team Coordinator",
  EXECUTIVE: "Executive",
  TELECALLER: "Telecaller",
  AUDIT_EXECUTIVE: "Audit Executive",
  MARKETING_MANAGER: "Marketing Manager",
};

export const ROLE_LABELS = {
  [ROLE.ADMIN]: "Admin",
  [ROLE.TEAM_LEAD]: "Team Lead",
  [ROLE.TEAM_COORDINATOR]: "Team Coordinator",
  [ROLE.EXECUTIVE]: "Executive",
  [ROLE.TELECALLER]: "Telecaller",
  [ROLE.AUDIT_EXECUTIVE]: "Audit Executive",
  [ROLE.MARKETING_MANAGER]: "Marketing Manager",
};

// Permission codes seeded in ph-wh-identity-svc (type: "Tele").
// Keep in sync with the migration in ph-wh-identity-svc/src/migrations/files/20260821100001_seed_tele_permissions_roles.ts
export const PERMISSION = {
  LEADS_ACCESS: "TELE.LEADS.ACCESS",
  LEADS_ADD: "TELE.LEADS.ADD",
  LEADS_UPDATE: "TELE.LEADS.UPDATE",
  LEADS_BYPASS_RESTRICTIONS: "TELE.LEADS.BYPASS_RESTRICTIONS",
  LEADS_VIEW_ALL_TEAMS: "TELE.LEADS.VIEW_ALL_TEAMS",
  ADMIN_SUMMARY_ACCESS: "TELE.ADMIN_SUMMARY.ACCESS",
  REPORT_POSTED_ACCESS: "TELE.REPORT_POSTED.ACCESS",
  REPORT_POSTED_VIEW_BUY_LEAD_PCT: "TELE.REPORT_POSTED.VIEW_BUY_LEAD_PCT",
  REPORT_POSTED_DOWNLOAD_CSV: "TELE.REPORT_POSTED.DOWNLOAD_CSV",
  REPORT_POSTED_DELETE_LEAD: "TELE.REPORT_POSTED.DELETE_LEAD",
  REPORT_POSTED_UPLOAD_RECORDING: "TELE.REPORT_POSTED.UPLOAD_RECORDING",
  REPORT_ATTEMPTED_ACCESS: "TELE.REPORT_ATTEMPTED.ACCESS",
  REPORT_SOURCE_POSTING_ACCESS: "TELE.REPORT_SOURCE_POSTING.ACCESS",
  REPORT_SOURCE_DETAILED_ACCESS: "TELE.REPORT_SOURCE_DETAILED.ACCESS",
  TARGETS_ACCESS: "TELE.TARGETS.ACCESS",
  SETTINGS_CAMPAIGNS_ACCESS: "TELE.SETTINGS_CAMPAIGNS.ACCESS",
  SETTINGS_LOCATIONS_ACCESS: "TELE.SETTINGS_LOCATIONS.ACCESS",
  MARKETING_SPEND_ACCESS: "TELE.MARKETING_SPEND.ACCESS",
  MARKETING_REPORT_ACCESS: "TELE.MARKETING_REPORT.ACCESS",
  TEAMS_ACCESS: "TELE.TEAMS.ACCESS",
  INCENTIVES_ACCESS: "TELE.INCENTIVES.ACCESS",
  INCENTIVES_VIEW_ALL_TEAMS: "TELE.INCENTIVES.VIEW_ALL_TEAMS",
  TEAM_DASHBOARD_ACCESS: "TELE.TEAM_DASHBOARD.ACCESS",
  TEAM_DASHBOARD_VIEW_ALL_TEAMS: "TELE.TEAM_DASHBOARD.VIEW_ALL_TEAMS",
  TEAM_DASHBOARD_DOWNLOAD_CSV: "TELE.TEAM_DASHBOARD.DOWNLOAD_CSV",
  FLAGGED_LEADS_ACCESS: "TELE.FLAGGED_LEADS.ACCESS",
};
